import { Outlet } from 'react-router-dom'
import { EUserRole } from 'models/user.model'
import globalStore from 'store'
import ExternalUrlRedirect from 'pages/public/ExternalUrlRedirect'

interface IProtectedRoutes {
  allowedRole: EUserRole[]
}
const ProtectedRoutesByUser = ({ allowedRole }: IProtectedRoutes) => {
  const user = globalStore(state => state.user)
  const landingPage = process.env.REACT_APP_LANDING_PAGE || ''

  const hasRole = user && allowedRole.some(role => role === user.role)

  const noUserRedirect = () => {
    return <ExternalUrlRedirect url={landingPage} />
  }

  return user && hasRole ? <Outlet /> : noUserRedirect()
}

export default ProtectedRoutesByUser
